var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67, 57)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.533066,33.1284638 L69.6771667,2.34474918 C68.1421859,0.905925821 66.0955447,0.106579508 63.9392621,0.106579508 L12.316394,0 C12.316394,0 0,0.781583061 0,11.7237459 L0,113.276254 C0,113.276254 0.548207449,125 12.316394,125 L92.683606,125 C92.683606,125 105,124.449339 105,113.276254 L105,38.7061248 C105,36.6100611 104.104595,34.6028137 102.533066,33.1284638 Z M69.841629,13.2691488 L91.3679081,33.5903084 L73.9349112,33.5903084 C73.9349112,33.5903084 69.8233554,33.4126759 69.8233554,29.6823931 C69.841629,25.9521103 69.841629,13.2691488 69.841629,13.2691488 Z M96.7951619,113.258491 C96.7951619,117.184169 92.683606,117.166407 92.683606,117.166407 L12.316394,117.166407 C8.47894187,117.166407 8.20483815,113.258491 8.20483815,113.258491 L8.20483815,11.7059827 C8.20483815,8.06451613 12.316394,7.79806736 12.316394,7.79806736 L61.6367908,7.79806736 L61.6367908,29.6646298 C61.6367908,40.5002132 73.9531848,41.3883757 73.9531848,41.3883757 L96.7951619,41.3883757 L96.7951619,113.258491 L96.7951619,113.258491 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,56.887218 C26,59.0428571 27.861913,60.7744361 30.1478261,60.7744361 L74.8521739,60.7744361 C77.138087,60.7744361 79,59.025188 79,56.887218 C79,54.7492481 77.138087,53 74.8521739,53 L30.1478261,53 C27.861913,53 26,54.7492481 26,56.887218 Z M74.8521739,72.612782 L30.1478261,72.612782 C27.861913,72.612782 26,74.3620301 26,76.5 C26,78.6379699 27.861913,80.387218 30.1478261,80.387218 L74.8521739,80.387218 C77.138087,80.387218 79,78.6379699 79,76.5 C79,74.3620301 77.138087,72.612782 74.8521739,72.612782 Z M74.8521739,92.2255639 L30.1478261,92.2255639 C27.861913,92.2255639 26,93.974812 26,96.112782 C26,98.2507519 27.861913,100 30.1478261,100 L74.8521739,100 C77.138087,100 79,98.2507519 79,96.112782 C79,93.974812 77.138087,92.2255639 74.8521739,92.2255639 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#D3D3D3",
    strokeWidth: 3,
    x: 1.5,
    y: 1.5,
    width: 237,
    height: 237,
    rx: 28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFile);
export default __webpack_public_path__ + "static/media/export-file.02cb970a982d750e77922d6e063ed054.svg";
export { ForwardRef as ReactComponent };